import { render, staticRenderFns } from "./navDataScreen.vue?vue&type=template&id=e62717a2&scoped=true&"
import script from "./navDataScreen.vue?vue&type=script&lang=js&"
export * from "./navDataScreen.vue?vue&type=script&lang=js&"
import style0 from "./navDataScreen.vue?vue&type=style&index=0&id=e62717a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62717a2",
  null
  
)

export default component.exports